import {domainType} from "../../modules/Common";

const GeneralClientBtmSheet = (props) =>{
    const {genClientbtmSheet, setGenClientbtmSheet} = props;

    const go365 = () =>{
        window.location.href = domainType(365);
    }
    
    return(
        <div className={`layerPopWrap halflayerPop ${genClientbtmSheet? 'on':''}`}>
            <div className="bg" onClick={()=>{setGenClientbtmSheet(false)}}></div>
            <div className="layerPopCont">
                <p className="popTitle noneX noBorder">사업자 번호를 다시 한번 확인해주세요.</p>
                <div className="contBox20 maxHScroll">
                    <p className="normalTit txtKeepall">
                        사업자 번호가 맞으시다면<br/>
                        대출통로BOX로 이동하셔서<br/>
                        대출 가능 한도를 알아보세요.
                    </p>
                </div>
                <div className="popBtnGroupWrap full flex">
                    {/* 비활성화  .on */}
                    <a className="btn btnPopClose" onClick={()=>{setGenClientbtmSheet(false)}}>닫기</a>
                    <a onClick={()=>{go365()}} className="btn btnPopClose on">대출통로BOX 이동</a>
                </div>
            </div>
        </div>
    )
}
export default GeneralClientBtmSheet;